module.exports = __webpack_public_path__ + "static/media/indent form.b19bde2a.svg";